import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetService {
  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  InsertUpdateAssetGroup(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetGroupMasterInsert/Update`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  LoadGroupMaster(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetGroupMasterSelect/Load`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  LoadAssetMaster(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetMasterSelect/Load`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  InsertUpdateAssetMaster(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESSAssetMasterInsertUpdate/Update`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  LoadAssetAdditionDetail(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetAdditionSelect/Load`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  InsertUpdateAssetAddition(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetAdditionInsertUpdate/Update`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  PORefrenceNumberDublicateCheck(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetAddition/PurchaseRefReturn`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  InsertUpdateAssetTransfer(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetAllotment/InsertUpdate`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  LoadAssetTransfer(AttendaceDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AssetAllotment_Select/Load`,
      this.session.SetClass(AttendaceDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }


}
